module.exports = __webpack_public_path__ + "static/hh-e356799e7c898b6826026da33f85c80b.jpg";